import { IconoirCalendar } from "@ey-xd/motif-icon";
import {
  MotifErrorMessage,
  MotifIcon,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { ProvisionBillingPreview } from "../../../../../../store/slices/ProvisionBillingPreviewSlice";
import {
  formatDateOnly,
  formatDateOnlyRange,
} from "../../../../../../utils/dateFunction";
import "./BillingDateSummary.scss";

interface BillingDateSummaryProps {
  interval: string;
  preview: ProvisionBillingPreview | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const BillingDateSummary = ({
  interval,
  preview,
  status,
  error,
}: BillingDateSummaryProps) => {
  const label =
    interval === "One Time" ? "Billing date" : "First billing period";
  let value = "";

  if (preview?.billingDisplayType === "date") {
    value = formatDateOnly(preview.billingDate);
  }

  if (preview?.billingDisplayType === "period") {
    value = formatDateOnlyRange(
      preview.firstBillingPeriodStartDate,
      preview.firstBillingPeriodEndDate,
    );
  }

  return (
    <div className="billing-date-summary">
      <div className="billing-date-summary__row">
        <div className="billing-date-summary__content">
          <span className="billing-date-summary__label">{label}</span>
          <div className="billing-date-summary__value">
            <MotifIcon iconFunction={IconoirCalendar} size="20" />
            {status === "loading" && (
              <div
                className="billing-date-summary__loader"
                aria-live="polite"
                aria-label="Calculating billing period"
              >
                <MotifProgressLoader
                  show
                  variant="circular"
                  size="xs"
                  tip="Loading..."
                />
              </div>
            )}
            {status !== "loading" && value}
          </div>
        </div>
      </div>

      {status === "failed" && (
        <div className="billing-preview-error" role="alert">
          <MotifErrorMessage showIcon>{error}</MotifErrorMessage>
        </div>
      )}
    </div>
  );
};

export default BillingDateSummary;
